export default {
    LOGIN: "Login",
    LOGIN_USERNAME: "Username",
    LOGIN_PASSWORD: "Password",
    LOGIN_CAPTCHA: "Captcha",
    LOGIN_PHONRNUMBER:"Phone number",
    LOGIN_PHONRNCAPTCHA:"Message authentication code",
    LOGIN_FORGOT_PASSWORD: "Forgot password?",
    LOGIN_LOGINING: "Logining",
    LOGIN_PLS_INPUT_USERNAME: "Please input username",
    LOGIN_PLS_INPUT_PASSWORD: "Please input password",
    LOGIN_USERNAME_OR_PASSWORD_INCORRECT: "Incorrect username or password",
    LOGIN_INCORRECT_USERROLE: "You are not allowed to login portal web.",

    NEW_PASSWORD:"New password",
    CONFIRM_NEW_PASSWORD:"Confirm new password",

    SETTING_ABOUT_ME: "About me",
    SETTING_LOGOUT: "Logout",

    BUTTON_ADD: "Add",
    BUTTON_EDIT: "Edit",
    BUTTON_DELETE: "Delete",
    BUTTON_EXPORT: "Export",
    BUTTON_IMPORT: "Import",
    BUTTON_SEARCH: "Search",
};



// WEBPACK FOOTER //
// ./src/components/locale/lang/en.js